import { Serializable } from '../../../core/models/serializable';
import { ThreadRelatedObjectType } from './thread-related-object-type.enum';
import { ThreadTopic } from './thread-topic.enum';
import { ThreadPostModel } from './thread-post-model';

export class ThreadModel implements Serializable<ThreadModel> {
  fromObject(object: any): ThreadModel {
    Object.assign(this, object);
    this.posts = [];
    if (object.posts && object.posts.length && object.posts.length > 0) {
      object.posts.forEach((p) => {
        let t = new ThreadPostModel();
        t = t.fromObject(p);
        this.posts.push(t);
      });
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public threadId: number;
  public threadRelatedObjectTypeId: ThreadRelatedObjectType;
  public threadTopicId: ThreadTopic;
  public threadRelatedObjectId: number;
  public createDate: Date;
  public createUserId: number;
  public isAlive: boolean;
  public posts: ThreadPostModel[];
}
